<template>
  <main>
    <app-header type="default"></app-header>
    <section class="l-container copy-right">
      <div class="stamp-history-wrap">
        <div class="sub-title">
          <h2>스탬프 카드 내역</h2>
          <p class="sub-txt">매장 스탬프 카드 신청내역을 확인하세요. </p>
        </div>
        <span class="stamp-icon">
          <img src="../assets/images/icon_stamp.png" alt="">
        </span>
        <router-link to="/regist">
        <div class="btn btn-blue">
          <span>등록</span>
        </div>
        </router-link>
      </div>
      <div class="card-list">
        <ul>
          <li v-for="item in 5" :key="item.key">
            <div class="card-top">
              <div class="card-img">
                <img src="../assets/images/card-img.png" alt="">
              </div>
              <div class="card-info">
                <p class="card-no">No.5</p>
                <p class="card-name">테스트카드이름</p>
                <p class="expiry-date">
                  <span>2019.01.01</span>까지
                </p>
              </div>
            </div>
            <div class="card-mid">
              <div class="label-txt">
                <span>카드ID</span>
                <p class="txt">V00A078B001M00013P0001FSC001</p>
              </div>
              <div class="label-txt">
                <span>적립갯수</span>
                <p class="txt">10개</p>
              </div>
            </div>
            <div class="card-btm">
              <div class="date-wrap">
                <p>
                  등록일시
                  <span>2019-09-19 15:00:00</span>
                </p>
                <p>
                  변경일시
                  <span>2019-09-29 15:00:00</span>
                </p>
              </div>
              <router-link to="/revise">
              <div class="btn btn-revise">
                <span>수정</span>
              </div>
              </router-link>
            </div>
          </li>
        </ul>
      </div>
    </section>
  </main>
</template>
<script>
import AppHeader from '../components/AppHeader.vue'
export default {
  name: 'Main',
  components: {
    AppHeader
  },
  data () {
    return {

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Main.vue